export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/50 via-background-50 to-background-100/30"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              实时更新 · 每日新鲜爆料
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-3">
              黑料在线
              <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-700 font-normal mt-2">
                最新爆料视频一站式观看平台
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 font-heading mb-6">
              海量黑料大瓜 · 每日更新 · 免费在线观看黑料
            </p>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              黑料在线汇聚全网最新最热的黑料视频正片，覆盖娱乐圈、网红圈、综艺幕后等热点领域。
              本站每日更新最新黑料大瓜，所有内容支持黑料在线播放，直接点播无需跳转第三方平台，
              让您第一时间掌握最新爆料动态。海量黑料在线视频免费观看，满足您的吃瓜需求。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">2000+</div>
                <div className="text-xs text-foreground-500 mt-1">黑料视频正片</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">最新爆料不间断</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">安全私密</div>
                <div className="text-xs text-foreground-500 mt-1">无需注册直接观看</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#media');
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始黑料在线观看
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#ranking');
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line text-lg"></i>
                查看今日热度榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20cinema%20stage%20with%20golden%20spotlight%20beams%20piercing%20through%20darkness%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20theatrical%20curtain%20texture%2C%20mysterious%20elegant%20atmosphere%2C%20editorial%20photography%20style%2C%20soft%20gradient%20lighting%2C%20luxurious%20velvet%20fabric%20folds%2C%20dramatic%20chiaroscuro%2C%20high%20contrast%20cinematic%20composition%2C%20sophisticated%20entertainment%20industry%20visual&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="黑料在线 - 最新爆料视频平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}